module.exports = " <div v-if=onBusinessHour class=-time-pointer :style=style _v-400a70e2=\"\"></div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-400a70e2!./~/vue-loader/lib/selector.js?type=template&index=0!./components/reservations/reservations-table/row/time-pointer.vue
// module id = 296
// module chunks = 0